const apostrophe_char = "’";

const possessiveString = (str) => {
  if (str == "") {
    return str;
  }
  var lastChar = str.slice(-1);
  var endOfWord =
    lastChar.toLowerCase() == "s" ? apostrophe_char : `${apostrophe_char}s`;
  return `${str}${endOfWord}`;
};

export default possessiveString;
